var configManager = require('../config/configManager');
/**
 * An object describing the bin data kept in cache
 * @typedef {Object} BinObject
 * @property {string} bin The partial or full card number this object represents
 * @property {ProfilingObject} profiling An object describing the current state of the bins profiling status
 */

 /**
  * @param {string} bin The bin value to initalize the object with
  * @param {ProfilingObject=} profilingObject The profiling details to include on this new bin object
  */
function BinObject (bin, profilingObject) {
  this.bin = bin;
  this.profiling = undefined;

  if(profilingObject !== undefined && profilingObject instanceof ProfilingObject){
    this.profiling = profilingObject;
  } else {
    this.profiling = new ProfilingObject(true);
  }
}

/**
 * An object describing the bins profiling
 * @typedef ProfilingObject
 * @property {boolean} required
 * @property {number} delay
 * @property {Date} startTime
 * @property {boolean} completed
 */

 /**
  * @param {boolean=true} required A flag to indicade if the bin requires profiling. 
  * @param {number=} delay The time in milliseconds the bin needs to complete profiling
  */
function ProfilingObject (required, delay) {
  this.required = true;
  this.delay = configManager.getSystemConfig().defaultBinProfilingDelay;
  this.startTime = 0;
  this.completed = false;

  if(required === true){
    this.required = true;
  }

  if(delay !== undefined && delay > 0){
    this.delay = delay;
  }
}

module.exports = BinObject;
module.exports.ProfilingObject = ProfilingObject;


//////////////////
// WEBPACK FOOTER
// ./models/binObject.js
// module id = 60
// module chunks = 5